import consts from "@/consts.js";
import Request from './request';

async function fetch(data) {
    return Request('get', "api/suppliers/", data);
}

async function fetchAll(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    return Request('get', "api/suppliers", data);
}

async function fetchAllForSelect(data) {
    if (!data) data = {};
    data.limit = consts.limitAll; //获取全部
    data.fieldFilter = ["id", "supplier_code", "supplier_name"]; //仅筛选少许必要字段
    return Request('get', "api/suppliers/select", data, false, false, true);
}


export default {
    fetch,
    fetchAll,
    fetchAllForSelect,
};